export default "__VITE_ASSET__AnXc1NqCYAMHqoYYbq_DbA__"